"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGiftBag(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12.979 0c1.489 0 2.714 1.17 2.803 2.638l.005.17v1.276h4.34a1.79 1.79 0 011.782 1.641l.006.146v16.342A1.79 1.79 0 0120.128 24H3.788A1.79 1.79 0 012 22.213V5.87a1.79 1.79 0 011.787-1.787h4.34V2.809c0-1.49 1.171-2.715 2.639-2.804l.17-.005h2.043zM8.127 5.616h-4.34a.258.258 0 00-.255.255v16.342c0 .138.117.255.255.255h16.34a.258.258 0 00.256-.255V5.87a.258.258 0 00-.255-.255h-4.341v1.277a.766.766 0 01-1.525.104l-.007-.104V5.616H9.659v1.277a.766.766 0 01-1.524.104l-.007-.104-.001-1.277zm3.823 14.299l-.049-.002a.77.77 0 01-.359-.12l-.003-.002-.012-.008a.763.763 0 01-.075-.058l-.003-.003-4.32-3.836c-.633-.624-1.044-1.516-1.044-2.388 0-1.816 1.49-3.285 3.32-3.285 1.002 0 1.928.441 2.553 1.148a3.414 3.414 0 012.553-1.148c1.83 0 3.319 1.469 3.319 3.285 0 .805-.35 1.627-.925 2.261l-.148.154-4.291 3.809-.004.001-.013.013a.762.762 0 01-.061.047l.078-.061a.772.772 0 01-.5.193h-.016zm.512-6.317l-.046.037a.77.77 0 01-.305.137l-.009.001-.034.006a.76.76 0 01-.061.007h-.091a.766.766 0 01-.162-.026l.058.013a.772.772 0 01-.36-.175l-.07-.072a.76.76 0 01-.15-.259l-.016-.052a.762.762 0 01-.008-.035l-.003-.014c-.155-.805-.923-1.421-1.8-1.421-.99 0-1.788.788-1.788 1.753 0 .392.185.837.453 1.156l.104.114 3.783 3.357 3.754-3.33c.353-.348.587-.856.587-1.297 0-.965-.799-1.753-1.787-1.753-.827 0-1.556.546-1.768 1.281l-.033.14a.709.709 0 01-.011.049l.01-.049a.762.762 0 01-.175.36l-.072.072zm.517-12.066h-2.043c-.656 0-1.204.506-1.27 1.147l-.006.13-.001 1.275h4.596V2.809c0-.657-.506-1.205-1.147-1.27l-.13-.007z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgGiftBag;
exports.default = _default;